export class NavigationHelper implements NavigationHelperInterface {
	constructor() {
		const localLocation = window.location.href;
		window.onpopstate = (event: any) => {
			if (event?.target?.location?.href !== localLocation) {
				this.onWindowChange();
			}
		};
	}

	onWindowChange(): void {
		throw new Error('onWindowChange, Method not implemented.');
	}
}

declare interface NavigationHelperInterface {
	onWindowChange(): void;
}
